//TODO: DON'T REMOVE ==> import crud action
import { customersActions as customers } from './customers/actions';
import { headerMenusActions as headerMenus } from './headerMenus/actions';
import { footerMenusActions as footerMenus } from './footerMenus/actions';
import { usersActions as users } from './users/actions';
import { systemConfigsActions as systemConfigs } from './systemConfigs/actions';
import { vendorFfmsActions as vendorFfms } from './vendorFfms/actions';
import { partnersActions as partners } from './partners/actions';
import { ordersActions as orders } from './orders/actions';
import { variantRelatedActions as variantRelated } from './variantRelated/actions';
import { productVariantsActions as productVariants } from './productVariants/actions';
import { orderReturnHistoriesActions as orderReturnHistories } from './orderReturnHistories/actions';
import { orderHistoriesActions as orderHistories } from './orderHistories/actions';
import { orderBatchesActions as orderBatches } from './orderBatches/actions';
import { ordersReadyToPickActions as ordersReadyToPick } from './ordersReadyToPick/actions';
import { ordersPickingActions as ordersPicking } from './ordersPicking/actions';
import { ordersDetailActions as ordersDetail } from './ordersDetail/actions';
import { ordersPickingListActions as ordersPickingList } from './ordersPickingList/actions';
import { locationsActions as locations } from './locations/actions';
import { ordersReturnActions as ordersReturn } from './ordersReturn/actions';
import { modalActions as modal } from './modal/actions';
import { transferOrdersActions as transferOrders } from './transferOrders/actions';
import { transferOrdersBatchActions as transferOrdersBatch } from './transferOrdersBatch/actions';
import { transferConfirmedPickActions as transferConfirmedPick } from './transferConfirmedPick/actions';
import { itemOrdersActions as itemOrders } from './itemOrders/actions';
import { bannedCustomersActions as bannedCustomers } from './bannedCustomers/actions';
import { chainStoresActions as chainStores } from './chainStores/actions';
import { inventoriesActions as inventories } from './inventories/actions';
import { inProcessOrdersActions as inProcessOrders } from './inProcessOrders/actions';
import { ordersAwaitingConfirmActions as ordersAwaitingConfirm } from './ordersAwaitingConfirm/actions';
import { orderBatchesPickingActions as orderBatchesPicking } from './orderBatchesPicking/actions';
import { ordersExchangeActions as ordersExchange } from './ordersExchange/actions';
import { ordersPendingForExchangeActions as ordersPendingForExchange } from './ordersPendingForExchange/actions';
import { deliveryActions as delivery } from './delivery/actions';
import { ordersTabTryBuyActions as ordersTabTryBuy } from './ordersTabTryBuy/actions';
import { locationStockChangesActions as locationStockChanges } from './locationStockChanges/actions';
import { rolePermissionsActions as rolePermissions } from './rolePermissions/actions';
import { rolePermissionGroupsActions as rolePermissionGroups } from './rolePermissionGroups/actions';
import { rolesActions as roles } from './roles/actions';

export default {
  //TODO: DON'T REMOVE ==> actions here
  customers,
  headerMenus,
  footerMenus,
  users,
  systemConfigs,
  vendorFfms,
  partners,
  orders,
  variantRelated,
  productVariants,
  orderReturnHistories,
  orderHistories,
  orderBatches,
  ordersReadyToPick,
  ordersPicking,
  ordersDetail,
  ordersPickingList,
  locations,
  ordersReturn,
  modal,
  transferOrders,
  transferOrdersBatch,
  transferConfirmedPick,
  itemOrders,
  bannedCustomers,
  chainStores,
  inventories,
  inProcessOrders,
  ordersAwaitingConfirm,
  orderBatchesPicking,
  ordersExchange,
  ordersPendingForExchange,
  delivery,
  ordersTabTryBuy,
  locationStockChanges,
  rolePermissions,
  rolePermissionGroups,
  roles,
};
